export const FORM_TYPES = {
	RESET_PASSWORD: 'reset-password',
	OTP: 'otp',
	NEW_PASSWORD: 'new-password'
};

export const FORM_TITLES = {
	[FORM_TYPES.RESET_PASSWORD]: {
		title: 'Şifremi Unuttum',
		description: 'Yeni şifrenizi belirleyebilmek için kayıtlı cep telefonunuzu girin.',
		showHeader: true
	},
	[FORM_TYPES.NEW_PASSWORD]: {
		title: 'Yeni Şifre Belirle',
		description: '',
		showHeader: true
	},
	[FORM_TYPES.OTP]: {
		showHeader: false
	}
};
